"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = require("../Image");

var _Image2 = _interopRequireDefault(_Image);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _default_profile = require("../../assets/default_profile.png");

var _default_profile2 = _interopRequireDefault(_default_profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

class Avatar extends _react.Component {
  constructor(...args) {
    var _temp;

    return _temp = super(...args), this.state = { error: false }, this.onError = () => {
      this.setState({ error: true });
    }, _temp;
  }

  render() {
    const _props = this.props,
          { src } = _props,
          props = _objectWithoutProperties(_props, ["src"]);
    return _react2.default.createElement(
      _Flex2.default,
      _extends({
        alignItems: "center",
        bg: "white",
        style: { overflow: "hidden" }
      }, props),
      !this.state.error && _react2.default.createElement(_Image2.default, { onError: this.onError, width: "100%", height: "100%", src: src })
    );
  }
}

Avatar.propTypes = {
  w: _propTypes2.default.number,
  h: _propTypes2.default.number,
  src: _propTypes2.default.string,
  borderRadius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Avatar.defaultProps = {
  src: _default_profile2.default,
  borderRadius: "50%",
  w: 1,
  h: 1
};

exports.default = Avatar;